<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<p class="mgb_5">
					<em class="lt_text">Base Date</em>
					<span class="mgr_5"> <CustomDatePicker v-model="base_date"/></span>
					<template v-if="user.company_id == 'jc'">
						<em class="lt_text">Aging Basis</em>
						<label class="mgr_5"><input type="radio" value="invoice" v-model="aging_base" /> Invoice Date</label>
						<label class="mgr_10"><input type="radio" value="ship" v-model="aging_base" /> Ship/PickUp Date</label>
					</template>
					<em class="lt_text">Sales Group</em>
					<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="sales_group_options" :displayDescription="true" v-model="sales_group_code"/></span>

					<em class="lt_text">Salesman</em>
					<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="reformattedSalesmans" :displayDescription="false" v-model="salesman_id"/></span>

					<span class="int_type_no_border mgr_5">
						<PartnerSelect v-model="bill_to_code" ph="Bill To" :showName="false" :restrictionOnly="restriction_only" @set-partner="setBill" />
					</span>

					<span class="int_type_no_border mgr_5">
						<PartnerSelect v-model="ship_to_code" ph="Ship To" :showName="false" :restrictionOnly="restriction_only" @set-partner="setShip" />
					</span>

					<em class="lt_text">Country</em>
					<span class="int_type_no_border mgr_10">
						<CodeSelect :width="100" :showDesc="false" :codes="countries" v-model="country" />
					</span>

					<em class="lt_text">State</em>
					<span class="int_type_no_border mgr_10"> <CodeSelect :width="100" :codeWidth="120" :showDesc="false" :codes="filteredStates" v-model="state" /> </span>
				</p>

				<p>
					<em class="lt_text">Over Date</em>
					<span class="int_type">
						<currency-input type="text" v-model.trim="over" :precision="0" :allow-negative="false" />
					</span>
					<select v-model="sort_key" class="tbl_select mgr_10" style="width:110px;">
						<option value="">Sort by</option>
						<option value="bill_to">Bill To</option>
						<option value="sales_rep">Sales Rep.</option>
						<option value="payment_code">Payment Code</option>
						<option value="sg_memo">SG Memo</option>
						<option value="over_date">Over Date</option>
					</select>
					<label v-if="restriction_only_available" class="mgr_10"><input type="checkbox" v-model="restriction_only" @change="restrictionOnlyChanged()" /> Restriction Only</label>

					<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
					<a href="javascript:void(0);" class="gray_bt mgr_5" @click="reset()">Reset</a>
					<a v-if="user.company_id == 'jc'" href="javascript:void(0);" class="gray_bt mgr_5" @click="ar_current_modal = true">A/R Summary (Current)</a>
					<font color="red"><b>Takes long time without search condition(s) </b></font>
				</p>
			</div>
		</div>

		<div class="fixed-table-container">
			<div class="mgb_20" style="margin: 0 auto;">
				<div class="al_center" style="margin: 0 auto;">
					<label class="mgr_5">
						<em class="lt_text">AR Amt.</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_total_ar_amount | toCurrency" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">Bal.</em>
						<!-- <input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.total_receipt_amount | toCurrency" /> -->
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_total_balance | toCurrency" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">Post Amt</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_post_check_amount | toCurrency" />
					</label>
					<label class="mgr_5">
						<em class="lt_text mgl_15">0 ~ 30</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_aging_date_0_30 | toCurrency" />
					</label>
					<template v-if="isBpNHp">
						<label class="mgr_5">
							<em class="lt_text">31 ~ 45</em>
							<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_aging_date_31_45 | toCurrency" />
						</label>
						<label class="mgr_5">
							<em class="lt_text">46 ~ 60</em>
							<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_aging_date_46_60 | toCurrency" />
						</label>
						<label class="mgr_5">
							<em class="lt_text">61 ~ 75</em>
							<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_aging_date_61_75 | toCurrency" />
						</label>
						<label class="mgr_5">
							<em class="lt_text">76 ~ 90</em>
							<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_aging_date_76_90 | toCurrency" />
						</label>
					</template>
					<template v-else>
						<label class="mgr_5">
							<em class="lt_text">31 ~ 60</em>
							<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_aging_date_31_60 | toCurrency" />
						</label>
						<label class="mgr_5">
							<em class="lt_text">61 ~ 90</em>
							<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_aging_date_61_90 | toCurrency" />
						</label>
					</template>

					<label class="mgr_5">
						<em class="lt_text">91 ~ 120</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_aging_date_91_120 | toCurrency" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">121 ~ 150</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_aging_date_121_150 | toCurrency" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">151 ~ 180</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_aging_date_151_180 | toCurrency" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">180 OVER</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.grand_aging_date_181_0 | toCurrency" />
					</label>
				</div>
			</div>
			<div class="table-wrapper" style="height: 90%">
				<table class="list_tbl sticky_list_tbl">
					<thead>
						<tr>
							<th style="width: 10px;"><input type="checkbox" v-model="allSelected" @change="() => root.list.forEach(el => (el.isSelected = allSelected))" /></th>
							<th style="width: 40px;">No</th>
							<th :style="isBpNHp ? 'width: 65px;' : 'width: 80px;'">Bill To</th>
							<th>Partner Name</th>
							<th v-if="company_id == 'jc'" style="width: 85px;">Ship/PickUp Date</th>
							<th style="width: 75px;">Sales Rep.</th>
							<th v-if="isBpNHp" style="width:75px;">Salesman</th>
							<th :style="isBpNHp ? 'width: 75px;' : 'width: 100px;'">SG Memo</th>
							<th style="width: 20px;">Upd</th>
							<th style="width: 85px;">Payment Code</th>
							<th style="width: 40px;">Country</th>
							<th style="width: 40px;">State</th>
							<th :style="moneyStyle">Total AR Amt.</th>
							<th :style="moneyStyle">Balance</th>
							<th :style="moneyStyle">Post Check</th>
							<th :style="moneyStyle">Under 30</th>
							<template v-if="isBpNHp">
								<th :style="moneyStyle">31~45</th>
								<th :style="moneyStyle">46~60</th>
								<th :style="moneyStyle">61~75</th>
								<th :style="moneyStyle">76~90</th>
							</template>
							<template v-else>
								<th :style="moneyStyle">31~60</th>
								<th :style="moneyStyle">61~90</th>
							</template>

							<th :style="moneyStyle">91~120</th>
							<th :style="moneyStyle">121~150</th>
							<th :style="moneyStyle">151~180</th>
							<th :style="moneyStyle">Over 180</th>

							<!-- <th :style="isBpNHp ? 'width: 100px;' : 'width: 120px;'">AR Memo</th> -->
							<th :style="isBpNHp ? 'width: 7%;' : 'width:8%'">AR Memo</th>
							<th style="width: 20px;">Upd</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in root.list" v-bind:key="index">
							<td class="al_left"><input type="checkbox" v-model="item.isSelected" /></td>
							<td class="al_left">{{ index + 1 }}</td>
							<td class="al_left truncate">
								<span :title="item.bill_to_code">{{ item.bill_to_code }}</span>
							</td>
							<td class="al_left truncate">
								<span :title="item.bill_to_name">{{ item.bill_to_name }}</span>
							</td>
							<td v-if="company_id == 'jc'" class="al_left">{{ item.oldest_delivery_pick_up_date }}</td>
							<td class="al_left truncate">
								<span :title="item.sales_group_name">{{ item.sales_group_name }}</span>
							</td>
							<td v-if="isBpNHp" class="al_left truncate">
								<span :title="item.salesman_name">{{ item.salesman_name }}</span>
							</td>
							<td><input type="text" class="l_int full_int" v-model.trim="item.sg_memo" :title="item.sg_memo" :readonly="state_scope_read_only" @focus="$event.target.select()" /></td>
							<td><a v-if="!state_scope_read_only" href="javascript:;" :class="item.sg_memo_org == item.sg_memo ? 'gray_bt2 disable_bt' : 'gray_bt2'" @click="updateSgMemo(item)">Upd</a></td>
							<td class="al_left truncate">{{ item.payment_term_name }}</td>
							<!--							<td class="al_left">{{ item.address_detail }}</td>-->
							<!--							<td class="al_left">{{ item.address_city }}</td>-->
							<td class="al_left truncate">
								<font v-if="code_of_us && code_of_us !== item.country" color="red">
									<b>{{ item.country }}</b>
								</font>
								<span v-else>{{ item.country }}</span>
							</td>
							<td class="al_left truncate">
								<span :title="item.address_state">{{ item.address_state }}</span>
							</td>
							<!--							<td class="al_left">{{ item.address_zipcode }}</td>-->
							<!--							<td class="al_right">{{ item.total_invoice_amount | toCurrency }}</td>-->
							<td class="al_right">
								<span v-if="state_scope_read_only">{{ item.total_ar_amount | toCurrencyZeroNull }}</span
								><a v-else href="javascript:;" @click="gotoArHistory(item.bill_to_code, item.bill_to_name, null, false)">{{ item.total_ar_amount | toCurrencyZeroNull }}</a>
							</td>
							<td class="al_right">
								<a href="javascript:;" @click="gotoArHistory(item.bill_to_code, item.bill_to_name, null, true)">{{ item.total_balance | toCurrency }}</a>
							</td>
							<td class="al_right">{{ item.post_check_amount | toCurrencyZeroNull }}</td>
							<td class="al_right">{{ item.aging_date_0_30 | toCurrency }}</td>
							<template v-if="isBpNHp">
								<td class="al_right">{{ item.aging_date_31_45 | toCurrency }}</td>
								<td class="al_right">
									<template v-if="item.aging_date_46_60 > 0">
										<span style="color:red;font-weight:bold;">{{ item.aging_date_46_60 | toCurrency }}</span>
									</template>
									<template v-else>
										{{ item.aging_date_46_60 | toCurrency }}
									</template>
								</td>
								<td class="al_right">
									<template v-if="item.aging_date_61_75 > 0">
										<span style="color:red;font-weight:bold;">{{ item.aging_date_61_75 | toCurrency }}</span>
									</template>
									<template v-else>
										{{ item.aging_date_61_75 | toCurrency }}
									</template>
								</td>
								<td class="al_right">
									<template v-if="item.aging_date_76_90 > 0">
										<span style="color:red;font-weight:bold;">{{ item.aging_date_76_90 | toCurrency }}</span>
									</template>
									<template v-else>
										{{ item.aging_date_76_90 | toCurrency }}
									</template>
								</td>
							</template>
							<template v-else>
								<td class="al_right">{{ item.aging_date_31_60 | toCurrency }}</td>
								<td class="al_right">
									<template v-if="item.aging_date_61_90 > 0">
										<span style="color:red;font-weight:bold;">{{ item.aging_date_61_90 | toCurrency }}</span>
									</template>
									<template v-else>
										{{ item.aging_date_61_90 | toCurrency }}
									</template>
								</td>
							</template>
							<td class="al_right">
								<template v-if="item.aging_date_91_120 > 0">
									<span style="color:red;font-weight:bold;">{{ item.aging_date_91_120 | toCurrency }}</span>
								</template>
								<template v-else>
									{{ item.aging_date_91_120 | toCurrency }}
								</template>
							</td>
							<td class="al_right">
								<template v-if="item.aging_date_121_150 > 0">
									<span style="color:red;font-weight:bold;">{{ item.aging_date_121_150 | toCurrency }}</span>
								</template>
								<template v-else>
									{{ item.aging_date_121_150 | toCurrency }}
								</template>
							</td>
							<td class="al_right">
								<template v-if="item.aging_date_151_180 > 0">
									<span style="color:red;font-weight:bold;">{{ item.aging_date_151_180 | toCurrency }}</span>
								</template>
								<template v-else>
									{{ item.aging_date_151_180 | toCurrency }}
								</template>
							</td>
							<td class="al_right">
								<template v-if="item.aging_date_181_0 > 0">
									<span style="color:red;font-weight:bold;">{{ item.aging_date_181_0 | toCurrency }}</span>
								</template>
								<template v-else>
									{{ item.aging_date_181_0 | toCurrency }}
								</template>
							</td>
							<!-- <td class="al_right">{{ item.aging_date_91_120 | toCurrency }}</td>
							<td class="al_right">{{ item.aging_date_121_150 | toCurrency }}</td>
							<td class="al_right">{{ item.aging_date_151_180 | toCurrency }}</td>
							<td class="al_right">{{ item.aging_date_181_0 | toCurrency }}</td> -->
							<!-- <td>{{ item.remark }}</td> -->
							<td><input type="text" class="l_int full_int" v-model.trim="item.ar_memo" :title="item.ar_memo" :readonly="state_scope_read_only" @focus="$event.target.select()" /></td>
							<td><a v-if="!state_scope_read_only" href="javascript:;" :class="item.ar_memo_org == item.ar_memo ? 'gray_bt2 disable_bt' : 'gray_bt2'" @click="updateArMemo(item)">Upd</a></td>
							<!-- <td><a href="javascript:;" :class="'gray_bt2' + ' '" @click="updateArMemo(item)">Update</a></td> -->
						</tr>
						<tr>
							<td :colspan="company_id == 'jc' ? 11 : 10"></td>
							<!--							<td colspan="1" class="al_right">{{ root.grand_total_amount | toCurrency }}</td>-->
							<td colspan="1" class="al_right truncate" :title="root.grand_total_ar_amount">{{ root.grand_total_ar_amount | toCurrency }}</td>
							<td colspan="1" class="al_right truncate" :title="root.grand_total_balance">{{ root.grand_total_balance | toCurrency }}</td>
							<td colspan="1" class="al_right truncate" :title="root.grand_post_check_amount">{{ root.grand_post_check_amount | toCurrencyZeroNull }}</td>
							<td colspan="1" class="al_right truncate" :title="root.grand_aging_date_0_30">{{ root.grand_aging_date_0_30 | toCurrency }}</td>
							<template v-if="isBpNHp">
								<td colspan="1" class="al_right truncate" :title="root.grand_aging_date_31_45">{{ root.grand_aging_date_31_45 | toCurrency }}</td>
								<td colspan="1" class="al_right truncate" :title="root.grand_aging_date_46_60">{{ root.grand_aging_date_46_60 | toCurrency }}</td>
								<td colspan="1" class="al_right truncate" :title="root.grand_aging_date_61_75">{{ root.grand_aging_date_61_75 | toCurrency }}</td>
								<td colspan="1" class="al_right truncate" :title="root.grand_aging_date_76_90">{{ root.grand_aging_date_76_90 | toCurrency }}</td>
							</template>
							<template v-else>
								<td colspan="1" class="al_right truncate" :title="root.grand_aging_date_31_60">{{ root.grand_aging_date_31_60 | toCurrency }}</td>
								<td colspan="1" class="al_right truncate" :title="root.grand_aging_date_61_90">{{ root.grand_aging_date_61_90 | toCurrency }}</td>
							</template>

							<td colspan="1" class="al_right truncate" :title="root.grand_aging_date_91_120">{{ root.grand_aging_date_91_120 | toCurrency }}</td>
							<td colspan="1" class="al_right truncate" :title="root.grand_aging_date_121_150">{{ root.grand_aging_date_121_150 | toCurrency }}</td>
							<td colspan="1" class="al_right truncate" :title="root.grand_aging_date_151_180">{{ root.grand_aging_date_151_180 | toCurrency }}</td>
							<td colspan="1" class="al_right truncate" :title="root.grand_aging_date_181_0">{{ root.grand_aging_date_181_0 | toCurrency }}</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td :colspan="isBpNHp ? 17 : company_id == 'jc' ? 16 : 15" class="al_right">즉시수금 OVER 60</td>
							<td :colspan="isBpNHp ? 7 : 5" class="al_right">{{ root.grand_over | toCurrency }}</td>
							<td colspan="2"></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="bottom_bt_box">
			<ul class="mgb_5">
				<li v-if="!state_scope_read_only">
					<a href="javascript:void(0);" v-on:click="Excel">Excel</a>
				</li>
				<li v-if="user.company_id == 'jc'">
					<a href="javascript:void(0);" v-on:click="sheet">Sheet</a>
				</li>
				<li v-if="!state_scope_read_only">
					<a href="javascript:void(0);" v-on:click="reportPrint">Print</a>
				</li>
				<li v-if="!state_scope_read_only">
					<a href="javascript:void(0);" v-on:click="confirmCustomerStatement">Customer Statement Print</a>
				</li>
			</ul>
			<div v-if="['newjigu'].includes(company_id)" style="clear: both;">
				<label class="right_option mgr_15"><input type="checkbox" v-model="show_credit" /> Show All Credit in Printed Customer Statement.</label>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'InvoiceList'" :draggable="false">
			<template slot="title">Invoice List</template>
			<template slot="body">
				<!-- <div class="popup_body"> -->
				<div style="width:1000px; height:400px;" v-on:keyup.esc="close()">
					<table class="list_tbl">
						<thead>
							<tr>
								<th width="11%">Invoice No</th>
								<th width="9%">Invoice Date</th>
								<th width="7%">Inv. Amt.</th>
								<th width="7%">Inv. Bal.</th>
								<th width="7%">P. Check</th>
								<th>Description</th>
								<th width="8%">Update</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="invoice in invoices" v-bind:key="invoice.invoice_no">
								<td class="al_left">
									<!-- {{ invoice.invoice_dn }} -->
									<a href="javascript:;" @click="gotoArHistory(invoice.bill_to_code, invoice.bill_to_name, invoice.invoice_no, false)">{{ invoice.invoice_dn }}</a>
									<!-- <a href="javascript:;" @click="selectInvoice(invoice)">{{ invoice.invoice_dn }}</a> -->
								</td>
								<td class="al_left">{{ invoice.invoice_date }}</td>
								<td class="al_right">{{ invoice.invoice_amount | toCurrencyZeroNull }}</td>
								<td class="al_right">{{ invoice.balance | toCurrencyZeroNull }}</td>
								<td class="al_right">{{ invoice.post_check_amount | toCurrencyZeroNull }}</td>
								<!-- <td class="al_left truncate">{{ invoice.Remark }}</td> -->
								<td><input type="text" v-model.trim="invoice.description" class="tbl_int" placeholder="To Customer" :readonly="state_scope_read_only" @focus="$event.target.select()" /></td>
								<td @click.stop="">
									<a v-if="modifiable" href="javascript:;" :class="invoice.description_org == invoice.description ? 'gray_bt2 disable_bt' : 'gray_bt2'" @click="updateDescription(invoice)">Update</a>
								</td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Close</a>
					</div>
				</div>
			</template>
		</Modal>

		<CustomerStatementCriteria
			v-if="showModal && modalName == 'customer_statement_criteria'"
			@close="closeModal()"
			:show_credit="show_credit"
			:show_PDC="show_PDC"
			:show_payment="show_payment"
			:init_payment_date="payment_date"
			@change_show_credit="boolean => (show_credit = boolean)"
			@change_show_PDC="boolean => (show_PDC = boolean)"
			@change_show_payment="boolean => (show_payment = boolean)"
			@change_payment_date="date => (payment_date = date)"
			@printStatement="printCustomerStatement()"
		/>
		<ArCurrentSummaryModal :visible="ar_current_modal" @close="ar_current_modal = false" />
		<SheetCopyPopup v-if="sheet_popup" :sheet="sheet_popup" @close="sheet_popup = null" />
	</div>
</template>

<script>
import { apiArAging, apiSelectCustomerStatement, apiIndex } from '@/api/report/report';
import { isStateScopeBlocked } from '@/api/index';
import CodeSelect from '@/components/common/CodeSelect';
import { apiGetBase64ReportTemplate, apiGetReportTemplate, companyMrtUrl, exportFile, objectCopy, objectToFormData, PrintType, Report } from '@/api/util';
import { apiSelectInvoiceList, apiUpdateDescription } from '@/api/sales/invoice.js';
import PartnerSelect from '@/components/common/PartnerSelect';
import Modal from '@/components/common/Modal';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { apiUpdatePartnerArMemo, apiUpdatePartnerSgMemo } from '@/api/partner/index.js';
import { today } from '@/utils/date.js';
// import { reorganizeInvAndPay, combineInvAndPDC } from '@/utils/customerStatement.js';
import CustomerStatementCriteria from '@/components/common/CustomerStatementCriteria.vue';
import ArCurrentSummaryModal from '@/views/report/ArCurrentSummaryModal.vue';
import SheetCopyPopup from '@/components/common/SheetCopyPopup';
import { defaultDataType } from 'export-xlsx';
import _ from 'lodash';

export default {
	name: 'arAging',
	data: function() {
		return {
			base_date: today(),
			aging_base: 'invoice',
			root: { list: [] },
			ar_current_modal: false,
			sheet_popup: null,
			sales_group_code: '',
			salesman_id: '',
			salesmans: [],
			salesGroups: [],
			states: [],
			countries: [],
			country: '',
			state: '',
			bill_to_code: '',
			ship_to_code: '',
			over: 0,
			invoices: [],

			code_of_us: null,

			modalName: '',
			showModal: false,
			saveParam: {},

			sort_key: '',

			show_credit: true,
			show_PDC: true,
			show_payment: false,
			payment_date: today(),

			allSelected: false,

			// #3406 : Restriction Only 보기. 체크박스는 조회자(index 표식)에게만 보이고, 잠금은 화면에 보이는 자료의 조회 응답 표식으로만 정한다.
			restriction_only_available: false,
			restriction_only: false,
			restriction_only_sales_groups: [],
			restriction_only_states: [],
			state_scope_read_only: false,
			// 앞선 요청의 늦은 응답이 화면 자료·잠금·필터 목록을 덮지 않게 하는 요청 순번.
			aging_seq: 0,
			restriction_only_filter_seq: 0,
		};
	},
	components: {
		CodeSelect,
		PartnerSelect,
		Modal,
		CustomDatePicker,
		CustomerStatementCriteria,
		ArCurrentSummaryModal,
		SheetCopyPopup,
	},
	computed: {
		filteredStates: function() {
			if (!this.country && this.user.company_id == 'newjigu') return this.states;

			const vm = this;
			let fStates = this.state_options.filter(s => s.country === vm.country);
			if (fStates.length === 0) vm.state = null;
			return fStates;
		},
		// #3406 : Restriction Only 를 체크하면 지정 State 보기용 필터 목록(State 는 지정 State, Sales Group 은 회사 전체)을 쓴다.
		sales_group_options() {
			return this.restriction_only ? this.restriction_only_sales_groups : this.salesGroups;
		},
		state_options() {
			return this.restriction_only ? this.restriction_only_states : this.states;
		},
		modifiable() {
			if (this.state_scope_read_only) return false;
			const menus = this.$session.get('menus');
			for (let i = 0; i < menus.length; i++) {
				if ((menus[i].path === this.$router.history.current.path || menus[i].path === this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn === 'Y') return true;
			}
			return false;
		},
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : '';
		},
		isBpNHp() {
			return ['beautyplus', 'hairplus'].includes(this.company_id);
		},
		selectedCustomerCodes() {
			return this.root.list.filter(el => el.isSelected).map(el => el.bill_to_code);
		},
		reformattedSalesmans() {
			//return this.salesmans.map(sm => ({ code: sm.user_id, name: sm.name }));
			if (this.sales_group_code && this.company_id == 'beautyplus') return this.salesmans.filter(sm => sm.sales_group_code == this.sales_group_code).map(sm => ({ code: sm.user_id, name: sm.name }));

			return _.uniqBy(this.salesmans, 'user_id').map(sm => ({ code: sm.user_id, name: sm.name }));
		},
		moneyStyle() {
			return this.isBpNHp ? 'width: 55px;' : 'width: 5%;';
		},
	},
	methods: {
		async updateDescription(invoice) {
			if (this.state_scope_read_only) return;
			if (invoice.description_org == invoice.description) return;

			//console.log(invoice);

			const { data } = await apiUpdateDescription(invoice);

			if (data.result) {
				this.$toast.success('Updated successfully');
				invoice.description_org = invoice.description;
				//invoice.receipt_remark_org = invoice.receipt_remark;
				this.$forceUpdate();
			} else {
				this.$toast.error('Failed');
			}
			// console.log(invoice);
		},
		selectInvoice(invoice) {
			if (invoice.invoice_type == 'A') return;
			else if (invoice.invoice_type != 'B' && !invoice.invoice_dn.startsWith('BC')) {
				// this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
				let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
				window.open(routeData.href, '_blank');
			}
		},
		async updateSgMemo(ar) {
			if (this.state_scope_read_only) return;
			if (ar.sg_memo_org === ar.sg_memo) return;
			if (!this.modifiable) {
				this.$toast.error('You do not have permission to update.');
				return false;
			}

			const { data } = await apiUpdatePartnerSgMemo({ code: ar.bill_to_code, sg_memo: ar.sg_memo });

			if (data.result) {
				this.$toast.success('Updated successfully');
				ar.sg_memo_org = ar.sg_memo;
				this.$forceUpdate();
			} else {
				this.$toast.error('Failed');
			}
		},
		async updateArMemo(ar) {
			if (this.state_scope_read_only) return;
			if (ar.ar_memo_org === ar.ar_memo) return;
			if (!this.modifiable) {
				this.$toast.error('You do not have permission to update.');
				return false;
			}

			const { data } = await apiUpdatePartnerArMemo({ code: ar.bill_to_code, ar_memo: ar.ar_memo });

			if (data.result) {
				this.$toast.success('Updated successfully');
				ar.ar_memo_org = ar.ar_memo;
				this.$forceUpdate();
			} else {
				this.$toast.error('Failed');
			}
		},
		async gotoArHistory(partner_code, partner_name, invoice_no, direct_to_ar_history) {
			if (direct_to_ar_history) {
				const query = { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name };
				// #3406 : 지정 State 자료의 잔액은 A/R History 의 같은 Restriction Only 보기로 연다.
				if (this.state_scope_read_only) query.restriction_only = 'true';
				let routeData = this.$router.resolve({ name: 'arHistory', query });
				window.open(routeData.href, '_blank');
			} else if (invoice_no) {
				this.closeModal();
				// let routeData = this.$router.resolve({ name: 'arHistory', query: { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, invoice_no: invoice_no, date_type_is_invoice: '1', all_date: '1' } });
				let routeData = this.$router.resolve({ name: 'arHistory', query: { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, invoice_no: invoice_no, date_type_is_invoice: '1' } });
				window.open(routeData.href, '_blank');
			} else {
				if (this.state_scope_read_only) return;
				if (this.company_id === 'jc') {
					const detail_param = { ...this.saveParam, bill_to_code: partner_code };
					const { data } = await apiArAging(objectToFormData(detail_param));
					this.invoices = data.aging_invoices || [];
				} else {
					const { data } = await apiSelectInvoiceList({ paging_yn: 'N', status_code: 'I', bill_to_code: partner_code, with_balance_only: true });
					this.invoices = data.invoiceList;
				}

				this.invoices.forEach(i => {
					i.description_org = i.description;
				});
				/* 무조건 보여주기  */
				this.modalName = 'InvoiceList';
				this.showModal = true;
				// if (this.invoices.length == 1) {
				// 	let routeData = this.$router.resolve({
				// 		name: 'arHistory',
				// 		query: { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, invoice_no: this.invoices[0].invoice_no, date_type_is_invoice: '1', all_date: '1' },
				// 	});
				// 	window.open(routeData.href, '_blank');
				// } else {
				// 	this.modalName = 'InvoiceList';
				// 	this.showModal = true;
				// }
			}

			//this.$router.push({ name: 'arHistory', query: { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, date_type_is_invoice: '1', all_date: '1' } });
			/*
			let routeData = this.$router.resolve({ name: 'arHistory', query: { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, date_type_is_invoice: '1', all_date: '1' } });
			window.open(routeData.href, '_blank'); */
		},

		closeModal() {
			this.showModal = false;
		},
		async selectData() {
			// #3406 : 화면 자료와 잠금은 마지막 요청의 응답으로만 바꾼다.
			const seq = ++this.aging_seq;
			const restriction_only = this.restriction_only;
			const paramObj = {
				salesGroupCode: this.sales_group_code || '',
				salesman_id: this.salesman_id || '',
				country: this.country || '',
				state: this.state || '',
				bill_to_code: this.bill_to_code || '',
				date: this.base_date || today(),
				sort_key: this.sort_key || '',
				ship_to_code: this.ship_to_code || '',
				over: this.over || 0,
			};

			if (this.company_id == 'jc' && this.aging_base == 'ship') paramObj.aging_base = 'ship';
			if (this.isBpNHp) paramObj.include_detail_period = true;
			if (restriction_only) paramObj.restriction_only = 'true';
			this.saveParam = objectCopy(paramObj);
			const param = objectToFormData(paramObj);
			let data;
			try {
				// 거부되면 안내 화면으로 가지 않고 체크만 푼다(공용 인터셉터가 안내 토스트를 띄운다).
				({ data } = restriction_only ? await apiArAging(param, { stateScopeOptional: true }) : await apiArAging(param));
			} catch (e) {
				if (!restriction_only || !isStateScopeBlocked(e)) throw e;
				if (seq === this.aging_seq) this.restrictionOnlyRejected();
				return;
			}
			if (seq !== this.aging_seq) return;
			// 잠금은 이 응답의 표식으로 목록과 같은 tick 에 바꾼다. 표식이 없으면 기본 보기(편집 가능)다.
			this.state_scope_read_only = !!(data && data.state_scope_read_only);
			if (data && data.value && Array.isArray(data.value.list)) {
				data.value.list.forEach(i => {
					i.ar_memo_org = i.ar_memo;
					i.sg_memo_org = i.sg_memo;
					i.isSelected = this.allSelected;
				});

				this.root = data.value;
			} else {
				this.root = { list: [] };
			}
			//console.log(this.root);
		},
		async index() {
			// #3406 : beautyplus 는 AR Aging 표식을 붙여 Restriction Only 체크박스 표식을 받는다. 목록은 Restriction OFF 와 같다.
			const state_scoped_company = this.company_id === 'beautyplus';
			const { data } = state_scoped_company ? await apiIndex('?for_ar_aging=true') : await apiIndex();
			if (state_scoped_company) this.restriction_only_available = !!data.restriction_only_available;
			this.salesmans = data.salesmanList;
			//console.log(this.salesmans);
			this.salesGroups = data.salesGroupList;
			this.states = data.stateList;
			this.countries = data.countryList;

			if (this.isBpNHp) this.countries.push({ code: 'NON-US', name: 'NON US' });

			this.findCodeOfUS();
		},
		// #3406 : 체크를 바꾸면 필터 목록이 바뀌므로 Sales Group·Salesman·State 선택을 비운다. 체크하면 지정 State 보기용 목록을 받는다.
		async restrictionOnlyChanged() {
			this.sales_group_code = '';
			this.salesman_id = '';
			this.state = '';
			const seq = ++this.restriction_only_filter_seq;
			this.restriction_only_sales_groups = [];
			this.restriction_only_states = [];
			if (!this.restriction_only) return;
			const { data } = await apiIndex('?for_ar_aging=true&restriction_only=true');
			// 그 사이 체크를 바꿨으면 버린다.
			if (seq !== this.restriction_only_filter_seq || !this.restriction_only) return;
			if (!data.restriction_only_available) {
				// 그 사이 Restriction 이 꺼졌다. 체크박스를 거두고 기본 보기로 돌아간다.
				this.restriction_only_available = false;
				this.restriction_only = false;
				return;
			}
			this.restriction_only_sales_groups = data.restrictionOnlySalesGroupList || [];
			this.restriction_only_states = data.restrictionOnlyStateList || [];
		},
		// #3406 : Restriction Only 요청이 형태 검사에서 거부됐다. 체크를 풀고 기본 필터 목록으로 돌아간다. 이미 보이던 자료의 잠금은 그 자료의 표식대로 둔다.
		restrictionOnlyRejected() {
			this.restriction_only = false;
			this.restrictionOnlyChanged();
		},
		findCodeOfUS() {
			let idx = this.countries.findIndex(el => el.name === 'UNITED STATES');
			if (idx > -1) this.code_of_us = this.countries[idx].code;
		},
		async Excel() {
			if (this.state_scope_read_only) return;
			this.$toast.warning('Export to Excel takes time. Please be patient...', { duration: 10000 });

			this.root.type = 'excel';
			//const reportTemplate = await apiGetReportTemplate('arAging', reportMrtUrl('arAging'));
			const reportTemplate = await apiGetReportTemplate('arAging', companyMrtUrl('arAging'));
			const report = new Report(reportTemplate, this.root, 'ArAging');
			exportFile(report, 'excel');
		},
		// #3312 JC Sheet: 화면 표의 순번·기본 정보와 mrt Excel 의 주소·연락처·This Year Sales 열을 합친 27열. 라벨은 고객 첨부 헤더와 같다.
		sheetHeaders() {
			return [
				{ key: 'display_no', name: 'No', dataType: defaultDataType.number },
				{ key: 'bill_to_code', name: 'Bill To', dataType: defaultDataType.string },
				{ key: 'bill_to_name', name: 'Partner Name', dataType: defaultDataType.string },
				{ key: 'oldest_invoice_date', name: 'Inv.Date', dataType: defaultDataType.date },
				{ key: 'oldest_delivery_pick_up_date', name: 'Ship/PickUp Date', dataType: defaultDataType.date },
				{ key: 'sales_group_name', name: 'Sales Rep', dataType: defaultDataType.string },
				{ key: 'sg_memo', name: 'SG Memo', dataType: defaultDataType.string },
				{ key: 'payment_term_name', name: 'Payment', dataType: defaultDataType.string },
				{ key: 'country', name: 'Country', dataType: defaultDataType.string },
				{ key: 'address_detail', name: 'Address Detail', dataType: defaultDataType.string },
				{ key: 'address_city', name: 'Address City', dataType: defaultDataType.string },
				{ key: 'address_state', name: 'State', dataType: defaultDataType.string },
				{ key: 'address_zipcode', name: 'Zip Code', dataType: defaultDataType.string },
				{ key: 'email', name: 'Email', dataType: defaultDataType.string },
				{ key: 'telephone', name: 'Telephone', dataType: defaultDataType.string },
				{ key: 'total_invoice_amount', name: 'This Year Sales', dataType: defaultDataType.currency },
				{ key: 'total_ar_amount', name: 'AR Amount', dataType: defaultDataType.currency },
				{ key: 'total_balance', name: 'OPEN BALAMT', dataType: defaultDataType.currency },
				{ key: 'post_check_amount', name: 'Post Check', dataType: defaultDataType.currency },
				{ key: 'aging_date_0_30', name: 'UNDER 30', dataType: defaultDataType.currency },
				{ key: 'aging_date_31_60', name: '31 ~ 60', dataType: defaultDataType.currency },
				{ key: 'aging_date_61_90', name: '61 ~ 90', dataType: defaultDataType.currency },
				{ key: 'aging_date_91_120', name: '91 ~ 120', dataType: defaultDataType.currency },
				{ key: 'aging_date_121_150', name: '121 ~ 150', dataType: defaultDataType.currency },
				{ key: 'aging_date_151_180', name: '151 ~ 180', dataType: defaultDataType.currency },
				{ key: 'aging_date_181_0', name: 'OVER 180', dataType: defaultDataType.currency },
				{ key: 'ar_memo', name: 'Remark', dataType: defaultDataType.string },
			];
		},
		// 화면 표의 No(index + 1) 를 얕은 복사본에 붙인다. root.list 의 원본 객체는 바꾸지 않는다.
		sheetRows() {
			return this.root.list.map((item, index) => Object.assign({}, item, { display_no: index + 1 }));
		},
		sheet() {
			if (!this.root.list.length) {
				this.$toast.error('Please search first');
				return false;
			}
			this.sheet_popup = { title: 'AR Aging (Sheet)', headers: this.sheetHeaders(), rows: this.sheetRows() };
		},
		async reportPrint() {
			if (this.state_scope_read_only) return;
			this.root.type = 'print';
			this.root.code_of_us = this.code_of_us;
			this.root.print_dt = this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss');
			// console.log(JSON.stringify(this.root, null, 4));
			//const reportTemplate = await apiGetReportTemplate('arAging', reportMrtUrl('arAging'));
			const reportTemplate = await apiGetReportTemplate('arAging', companyMrtUrl('arAging'));
			const report = new Report(reportTemplate, this.root, 'ArAging', PrintType.Normal, false, false, null, 70);
			this.$store.commit('setReport', report);
		},
		setBill(partner) {
			this.bill_to_code = partner.code;
			this.selectData();
		},
		setShip(partner) {
			this.ship_to_code = partner.code;
			this.selectData();
		},
		reset() {
			this.state = '';
			this.country = '';
			this.bill_to_code = '';
			this.ship_to_code = '';
			this.sales_group_code = '';
			this.over = 0;
			this.aging_base = 'invoice';
			if (this.restriction_only) {
				this.restriction_only = false;
				this.restrictionOnlyChanged();
			}

			this.show_credit = true;
			this.show_PDC = true;
			this.show_payment = false;
			this.payment_date = today();

			this.allSelected = false;
		},
		async confirmCustomerStatement() {
			if (this.state_scope_read_only) return;
			if (!(this.selectedCustomerCodes && this.selectedCustomerCodes.length)) {
				if (!this.root.list.length) this.$toast.error('No Data to Print');
				else this.$toast.error('Please, Select Customer First.');
				return;
			} else if (!this.saveParam.salesGroupCode && this.selectedCustomerCodes.length > 100 && !['development', 'test'].includes(process.env.NODE_ENV)) {
				this.$toast.error('When Count of Bills is Over 100,<br />Can not Print Customer Statement Because of System Overload.', { duration: 10000 });
				return;
			}

			this.printCustomerStatement();
		},
		printCustomerStatement() {
			if (this.state_scope_read_only) return;
			if (this.selectedCustomerCodes.length > 20) {
				this.$alertify.confirm(this.selectedCustomerCodes.length + ' bills have been selected. Would you like to print it?', () => this.customerStatementPrint());
			} else {
				this.customerStatementPrint();
			}
		},
		async customerStatementPrint() {
			const param = objectToFormData({
				partner_codes: this.selectedCustomerCodes,
				comparison_target: this.saveParam.ship_to_code ? 'ship_to_code' : 'bill_to_code',
				date: today(),
				payment_date: this.payment_date,
				show_credit: this.show_credit,
				show_PDC: this.show_PDC,
				show_payment: this.show_payment,
			});
			const { data } = await apiSelectCustomerStatement(param);

			// reorganizeInvAndPay(data.data, this.company_id);
			// if (['newjigu'].includes(this.company_id)) combineInvAndPDC(data.data);

			const reportTemplate = await apiGetBase64ReportTemplate('customerStatement', companyMrtUrl('customerStatement'));
			let report = null;
			if (this.isBpNHp) {
				let ccList = [];
				if (data.data.length === 1) {
					if (data.data[0].customer.email) ccList.push(data.data[0].customer.email);
				}
				report = new Report(reportTemplate, data, 'CustomerStatement', PrintType.Normal, false, false, ccList);
				this.$store.commit('setReport', report);
			} else {
				report = new Report(reportTemplate, data, 'CustomerStatement', PrintType.Normal, false, false);
				exportFile(report, 'pdf');
			}
		},
	},
	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_arAging');
		this.$store.commit('setSubTitle', 'Report -> AR Aging');
		this.index();
	},
};
</script>

<style scoped lang="scss"></style>
